import { dateSorter } from '@components';
import { ServiceHistory } from '@services';
import { Tooltip } from 'antd';
import dayjs from 'dayjs';

export const Columns = () => [
  {
    title: 'Date',
    key: 'creationTime',
    dataIndex: 'creationTime',
    width: 70,
    ...dateSorter,
    render: (creationTime: string) => dayjs(creationTime).format('DD/MM/YYYY'),
  },
  {
    title: 'Service',
    key: 'title',
    width: 120,
    render: (history: ServiceHistory) => {
      const text = [
        ...new Set((history.reminderServices ?? []).map((s) => s.reminderName).filter(Boolean)),
      ].join(', ');
      return (
        <Tooltip title={text}>
          <span style={{ display: 'block', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {text}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: 'Mileage',
    dataIndex: 'mileage',
    key: 'mileage',
    width: 80,
    render: (mileage: number) => mileage,
  },
];
